import { Box, Stack } from "@mui/material"

const LendingLogo = () => {
  return (
    <Stack alignItems='center' className='mb-6'>
      <Box className='p-3 bg-secondary rounded-full'>
        <svg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'>
          <path d='M9.66817 13.2715V6.83984H6.33203V16.4955H9.66817H16.0001V13.2715H9.66817Z' fill='#72976B' />
          <path
            d='M11.4769 3.94322C12.2563 4.36956 12.6681 5.10652 12.6702 5.8577V10.0622H15.9979V5.8577C15.9979 5.64859 15.9811 5.43744 15.9559 5.22224C15.792 3.89855 15.1681 2.80022 14.1429 1.91708C13.084 1.00958 11.8319 0.550755 10.4181 0.5C10.3782 0.5 10.3403 0.50406 10.3004 0.50406H0.144958C0.0987395 0.50406 0.052521 0.50406 0.00630252 0.506091C0.00630252 0.534513 0.00210084 0.560906 0.00210084 0.589329V3.62651C0.00420168 5.28721 0.00420168 6.94791 0.00420168 8.60862H0V16.5H3.34034V11.5707V8.60862C3.34034 6.98446 3.34034 5.3603 3.33824 3.73614C3.33824 3.66914 3.34454 3.6326 3.40966 3.62448C3.42017 3.62448 3.43067 3.62245 3.44328 3.62245C5.69958 3.62651 7.95588 3.62448 10.2101 3.62651C10.6597 3.62651 11.084 3.72802 11.4769 3.94322Z'
            fill='#72976B'
          />
        </svg>
      </Box>
    </Stack>
  )
}

export default LendingLogo
